import * as React from 'react';
import { Box } from '@mui/material';
// import Loading from "../../../metrics/ListItems/loading"
import Loading from "../../../../../auxiliares/loading"
import DetailPid from '../detail/detailPid';
import { options } from '@config';
import { useParams } from 'react-router-dom';

const DetailPidContainer = () => {
    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true); 

    const params = useParams();

    const handleListPoints = async () => {
        const response = await fetch((options.api.url + "point"), {
            method: 'GET',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
        });
    
        const data = await response.json();

        const items =  data.pointsSearched

        return items
    }

    React.useEffect(()=> {
        const db = handleListPoints().then((e) => {
            setItems(e);
            setLoading(false);
        });
    },[loading]);

    return (
        <Box>
            {loading ? <Loading/>: <DetailPid items={items}/>}
        </Box>
    )
}

export default DetailPidContainer;